import React, { Component } from 'react';
import WalkIn from './WalkIn';

class IndexWalkIn extends Component {
  render() {
    const walkIns = this.props.entries
    const admin = this.props.admin
    return (
      <div className="row">
        <h1 className="title has-text-centered"> Activity Entries </h1>
        <h2> Total Entries: { walkIns.length } </h2>
          {walkIns.map(walkIn => <WalkIn key={walkIn.id} {...walkIn} admin={admin} />)}
      </div>
    );
  }
}

export default IndexWalkIn;
